import React from "react";
import { motion } from "framer-motion";
import { HERO } from "../constants/testIds";
import { useContent } from "../hooks/useContent";

/**
 * Full-width promotional banner at the very top of the page,
 * above the navbar. No rounded panel — edge to edge.
 */
const Hero = () => {
    const { data: heroData } = useContent("hero");

    const content = heroData?.data || {};

    const trustLines = content.trust_lines || [
        { label: "🚚 توصيل مجاني ابتداءً من 200 درهم • شحن سريع خلال 24 إلى 72 ساعة في جميع أنحاء المغرب", color: "blue" },
    ];

    return (
        <section
            id="top"
            data-testid={HERO.root}
            className="relative w-full overflow-hidden bg-[#6d1a2d] text-[#F7F1E3]"
        >
            {/* Scrolling delivery message — full width, no rounded corners */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.7 }}
                className="relative overflow-hidden h-10 flex items-center"
            >
                <div className="dp-marquee flex whitespace-nowrap">
                    {[1, 2].map((i) => (
                        <span
                            key={i}
                            dir="rtl"
                            className="px-8 text-[13px] md:text-sm font-medium"
                        >
                            {trustLines[0]?.label ||
                                "🚚 توصيل مجاني ابتداءً من 200 درهم • شحن سريع خلال 24 إلى 72 ساعة في جميع أنحاء المغرب"}
                        </span>
                    ))}
                </div>
            </motion.div>
        </section>
    );
};

export default Hero;
